export const parseCompanySettings = (data) => {
  try {
    if(typeof data === "string")
      return JSON.parse(data);
    return data;
  } catch (err) {
    return data;
  }
}